import { Link } from "@/components/shared/link";
import { ArrowLeft } from "@/components/shared/icons";
import { Typography } from "@/components/shared/typography";
import { Button } from "@/components/ui/button";
import { View } from "@/components/ui";
import { useWindowDimensions } from "@/components/hooks/use-window-dimension/";
import { InvoicePaymentStatusEnum } from "@/__generated__/graphql";
import type { InvoiceDetailScreenProps } from "./types";
import { Divider } from "@/components/shared/divider";
import { AvailableVoucher } from "./available-voucher";
import { InvoiceDetailCard } from "./InvoiceDetailCard";
import { BottomActions } from "@/components/shared/bottom-actions";

export const InvoiceDetailScreen = ({
  invoice,
  handlePay,
  loading,
  //   refetch,
}: InvoiceDetailScreenProps) => {
  const { isMobile } = useWindowDimensions();

  const renderPayButton = () => {
    if (
      loading ||
      invoice.paymentStatus === InvoicePaymentStatusEnum.Paid ||
      invoice.paymentStatus === InvoicePaymentStatusEnum.StripeProcessing
    ) {
      return null;
    }

    if (isMobile) {
      return (
        <BottomActions direction="col" gap="lg">
          {[
            InvoicePaymentStatusEnum.Unpaid,
            InvoicePaymentStatusEnum.Underpaid,
          ].includes(invoice.paymentStatus) && <AvailableVoucher />}
          <Button
            size="lg"
            variant="primary"
            color="CTA"
            fullWidth="full"
            rounded="full"
            onClick={handlePay}
            children="Pay"
          />
        </BottomActions>
      );
    }

    return (
      <Button
        variant="primary"
        color="CTA"
        className="mr-4 min-w-[100px] md:mr-0"
        rounded="full"
        onClick={handlePay}
        children="Pay"
      />
    );
  };

  return (
    <View className="my-0 md:my-5">
      <View className="flex flex-row items-center justify-between gap-2 md:mb-4">
        <View className="flex flex-row items-center gap-2 p-4 md:p-0">
          {isMobile && (
            <Link href="/profile/invoices">
              <ArrowLeft className="size-5" />
            </Link>
          )}
          <Typography variant="label-md">Invoice Details</Typography>
        </View>
        {renderPayButton()}
      </View>
      <Divider className="my-0 md:my-4" />

      {!isMobile &&
        [
          InvoicePaymentStatusEnum.Unpaid,
          InvoicePaymentStatusEnum.Underpaid,
        ].includes(invoice.paymentStatus) && (
          <View className="my-4">
            <AvailableVoucher />
          </View>
        )}
      <InvoiceDetailCard invoice={invoice} loading={loading} />
    </View>
  );
};
